import React from 'react';
import { Pricing } from '@klangio/react-shared-elements';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  app: {
    textAlign: 'center',
    color: '#fff',
  },
}));

const PricingContainerWidget = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.app}>
      <Pricing wordpress />
    </div>
  );
};

export default PricingContainerWidget;
